import actions from './actions';

const { CORTE_CAJA } = actions;

const initialState = {
  data: [],
};

const corteCajaReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case CORTE_CAJA:
      return {
        ...state,
        data: data,
      };
    default:
      return state;
  }
};

export default corteCajaReducer;
